import { Card, CardComponentVariant } from "@/components/pageCards/card";

import { FC } from "react";

import { CustomerWithDetailsAndCode } from "server/coreApi/customers/types.js";

import { CommunicationSection } from "./communication/CommunicationSection";

interface CustomerCommunicationCardProps {
  customer: CustomerWithDetailsAndCode;
}

export const CustomerCommunicationCard: FC<CustomerCommunicationCardProps> = ({
  customer,
}) => {
  const templates: ("mobile" | "tablet")[] = ["tablet", "mobile"];

  return (
    <Card
      title={"drawerLabels:communication"}
      variant={CardComponentVariant.DRAWER}
    >
      {templates.map((template) => (
        <CommunicationSection
          key={template}
          customer={customer}
          type={template}
        />
      ))}
    </Card>
  );
};
